import { EServiceTypes } from '../publicationPackages/types';

export interface IPaidPublicationState {
  price: number;
  days: number;
  token: string;
  isPaid: boolean;
  highDemandCoefficient: number;
  restriction: IRestriction;
  autoProlong: boolean;
  initial?: boolean;
  /**
   * @deprecated
   */
  tariffIdentificator?: ITariffIdentificator;
  /**
   * @deprecated
   */
  type: EType | null;
}

export interface IRestriction {
  /** Есть ли ограничния **/
  isAllowed: boolean;
  /** Причина недоступности **/
  restrictionType?: ERestrictionType;
}
export enum ERestrictionType {
  /** Исчерпан лимит объявлений для субагента **/
  'SubAgentLimitExceeded' = 'subAgentLimitExceeded',
  /** Когда у субагента есть запрет на топ и премиум **/
  'DeniedByStrategy' = 'deniedByStrategy',
  /** У пользователя запрет на размещение **/
  'DeniedBySanctions' = 'deniedBySanctions',
}

export interface ITariffIdentificator {
  tariffId: number;
  tariffGridType: string;
  days: number;
  periodType: string;
  serviceTypes: EServiceTypes[];
}

export enum EType {
  /** Ограниченная по дням публикация, подневная тарификация **/
  'DailyLimited' = 'dailyLimited',
  /** Бессрочная публикация, подневная тарификация **/
  'DailyTermless' = 'dailyTermless',
  /** Тарификация за весь период **/
  'Periodical' = 'periodical',
}
